import { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import Application from "../models/Application.tsx"
import AddtionalDocument from "../models/AdditionalDocument.tsx";

interface Props {
  identifier: string,
  label: string,
  application: Application,
  property_createdOn: string,
  property_filename: string,
  property_Id: string,
  SetApplication: (application: Application) => void
}

const DocumentComponent = ({ identifier, label, application, property_createdOn: prop_createdOn, property_filename: prop_filename, property_Id: prop_Id, SetApplication }: Props) => {
  const { authorization, SetAuthorization } = useAuth();
  const [error, SetError] = useState(false);

  const Upload = (event: React.ChangeEvent) => {
    const file = event.target.files[0];
    const filename = file.name;

    // Verify maximum file size
    if (file.size > 4000000) {
      SetError(true);
      return;
    }

    // Send document to server
    const data = new FormData();
    data.append("Token", authorization.Token);
    data.append("BusinessId", application.BusinessId.toString());
    data.append("File", file);
    const options = {
      method: "POST",
      body: data
    };

    fetch("/api/document", options)
      .then(response => response.text())
      .then(data => { 
        var documentId = Number(data);
        fetch("/api/additionaldocument?token=" + authorization.Token + "&documentId=" + documentId)
          .then(response => response.json())
          .then(document_data => {
            var document:AddtionalDocument = document_data;
            SetApplication((prevState) => ({ ...prevState, [prop_Id]: document.DocumentId, [prop_filename]: document.Filename, [prop_createdOn]: document.CreatedOn }));
          })
          .catch(error => console.log(error));
      })
      .catch(error => console.error(error));
  }

  const Delete = () => {    
    SetApplication((prevState) => ({ ...prevState, [prop_Id]: null, [prop_filename]: null }));
  }

  return (
    <>
      <Snackbar open={error} onClose={() => SetError(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }} autoHideDuration={5000}>
        <Alert severity="error" variant="filled" sx={{ width: "100%", padding: 2 }}>
          Document exceeds the 4MB maximum file size.
        </Alert>
      </Snackbar>

      {application[prop_filename] ?
        <p className="fileUploadParag">
          <label className="uploadInfo">
            {label}
            {label == "Proof of Status (optional)" &&
              <span className="tooltip">
                <img src="/images/icon-inquiry.png" alt="Proof of Status" />
                <span className="tooltiptext">Proof of Status is mandatory for in-country applicants</span>
              </span>}&nbsp;:
            <span className="file-name"> <a href={'/api/document?token=' + authorization.Token + '&documentId=' + application[prop_Id]} download>{application[prop_filename]}</a>
              {authorization.IsAdministrator && <>&nbsp;&nbsp;{Moment.tz(application[prop_createdOn], "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy hh:mm A")}</>}&nbsp;
              <span className="tooltip">
                <img src="/images/icon-delete.png" alt="Delete" onClick={Delete} />
                <span className="tooltiptext">Delete Document</span>
              </span>
            </span>
          </label>
        </p>:
        <p className="fileUploadParag">
          {label}&nbsp;
          {label == "Proof of Status (optional)" &&
            <>
              <span className="tooltip">
                <img src="/images/icon-inquiry.png" alt="Proof of Status" />
                <span className="tooltiptext">Proof of Status is mandatory for in-country applicants</span>
              </span>&nbsp;
            </>}&nbsp;
          <label htmlFor={identifier} className="custom-file-label">Upload</label>         
          <input id={identifier} type="file" className="custom-file-input" onChange={Upload} accept=".pdf, .doc, .docx" />
          <span className="file-name"></span>
        </p>}
    </>
  )
};

export default DocumentComponent;